import { jsx as w } from "react/jsx-runtime";
import { createContext as C, useContext as J, useState as d, useRef as O, useEffect as m, useCallback as S } from "react";
const N = C(void 0), x = (o) => o === "local" ? localStorage : sessionStorage, _ = ({ children: o }) => {
  const [t, r] = d(null), [c, i] = d(), [n, p] = d({}), l = O(void 0);
  m(() => {
    const e = JSON.parse(localStorage.getItem("appState") || "{}"), s = JSON.parse(sessionStorage.getItem("appState") || "{}");
    p({ ...e, ...s });
  }, []);
  const A = S((e) => {
    l.current = e;
  }, []), u = S((e, s, a = "session") => {
    p((g) => {
      const f = { ...g, [e]: { ...g[e], ...s } };
      return x(a).setItem("appState", JSON.stringify(f)), f;
    });
  }, []), I = S((e, s, a = "session") => n[e] ? n[e] : (u(e, s, a), s), [n, u]), v = S((e, s) => {
    let a = `scrollPos_${e}`;
    sessionStorage.removeItem(a), s === void 0 && (s = t == null ? void 0 : t.scrollTop), s !== void 0 && sessionStorage.setItem(a, s.toString());
  }, [t]), P = S((e) => {
    const s = sessionStorage.getItem(`scrollPos_${e}`);
    s && (t == null || t.scrollTo({ top: Number(s) }));
  }, [t]);
  return /* @__PURE__ */ w(N.Provider, { value: { mainEl: t, setMainEl: r, state: n, setViewState: u, getViewState: I, setScrollPosition: v, restoreScrollPosition: P, setStudentAppBarEl: i, studentAppBarEl: c, nativeDownload: l.current, setNativeDownload: A }, children: o });
}, $ = () => {
  const o = J(N);
  if (!o)
    throw new Error("useAppContext must be used within an AppProvider");
  return o;
}, h = (o, t, r = "session") => {
  const c = x(r), [i, n] = d(() => {
    const p = c.getItem(o);
    return p ? JSON.parse(p, T) : t;
  });
  return m(() => {
    c.setItem(o, JSON.stringify(i));
  }, [o, i, c]), [i, n];
}, T = (o, t) => {
  if (typeof t == "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(t)) {
    const r = new Date(t);
    if (!isNaN(r.getTime())) return r;
  }
  return t;
};
export {
  _ as AppContextProvider,
  $ as useApp,
  h as useAppState
};
//# sourceMappingURL=index.js.map
